import { TypedError } from './TypedError'

/**
 * ADT Schema 错误
 */
export abstract class SchemaError extends TypedError {}
